'use client';

import { HubDestCard } from '@/features/hub/shared/HubComponents';
import { HubCardGrid, HubCardItem } from '@/features/hub/shared/HubMotion';

export default function LandingHubDestinations({ destinations = [] }) {
  return (
    <HubCardGrid className="hub-card-grid hub-home-destination-grid mt-3">
      {destinations.map((dest) => (
        <HubCardItem
          key={dest.href}
          as="div"
          className={`destination-grid__item destination-grid__item--${dest.accent}`}
        >
          <HubDestCard
            href={dest.href}
            bgSrc={dest.bgSrc}
            icon={dest.icon}
            iconSrc={dest.iconSrc}
            title={dest.title}
            description={dest.description}
            ctaLabel={dest.ctaLabel}
            accent={dest.accent}
          />
        </HubCardItem>
      ))}
    </HubCardGrid>
  );
}
